import React, { useEffect, useState, Suspense } from "react";
import { Route, Routes, useLocation, useNavigate, Link } from 'react-router-dom';
import Index from "./pages";
import ScrollToTop from "components/navigation/scroll_to_top";
import Footer from "components/navigation/footer";


function App(props) {

  useEffect(() => {
  }, []);

  return (
    <Suspense fallback={<div id="preloader">Loading ... </div>}>
      <main>
        <Index {...props} />
      </main>
    </Suspense>
  );
}

function withRouter(Component) {
  function ComponentWithRouterProp(props) {
    const location = useLocation();
    const navigate = useNavigate();
    const searchParams = new URLSearchParams(window.location.search);

    // Can't useParams() here because it have not defined
    return (
      <Component
        {...props}
        useRouter={() => ({ location, navigate, link: Link, searchParams })}
      />
    );
  }
  return ComponentWithRouterProp;
}

// export default App;
export default withRouter(App);
